import {
  baasBalance,
  baasMobile,
  green,
  red,
  copy,
  eye,
  bank,
} from 'assets/images/images';
import {DashboardLayout, TableLayout} from 'components';
import React from 'react';
import {useNavigate} from 'react-router';
import {GoBack} from '../components/GoBack';
import CardSummary from 'components/CardSummary';

function CustomerWalletDetails() {
  const navigate = useNavigate();

  return (
    <DashboardLayout
      bg="bg-white80"
      topPadding="pt-8"
      xlLeftMargin="xl:ml-12"
      breadCrumbs={
        <div className="flex items-center">
          <img src={baasMobile} alt="" />
          <p className="ml-2 -mb-1">Customers</p>
        </div>
      }
    >
      {' '}
      <div className="flex items-center gap-4">
        <GoBack goBack={() => navigate(-1)} />
      </div>
      <h3 className="text-grey text-[18px] font-medium mt-8">
        Wallets details
      </h3>
      <div className="grid lg:grid-cols-2 gap-4 mt-7">
        <div className="flex flex-col gap-3">
          <div className="bg-white rounded-lg p-4">
            <div className="flex items-center gap-2">
              <img alt="wallet" src={baasBalance} />

              <div className="flex flex-col gap-1">
                <p className="text-body  font-medium text-sm">
                  Available Balance
                </p>
                <h2 className="font-semibold text-[24px] text-grey">
                  ₦32,038,039
                </h2>
              </div>
            </div>
            {/* <h4 className="mt-1 text-[10px] font-medium text-deepBlue300 lg:ml-[50px]">
              Ledger Balance:{' '}
              <span className="ml-2 font-semibold text-[14px]">
                ₦60,038,039
              </span>
            </h4> */}
          </div>
          <div className="grid lg:grid-cols-2 gap-4 h-full">
            <CardSummary
              img={green}
              title="Total Collections"
              body="₦12,038,039"
              titleClassName="text-sm"
              bodyClassName="text-[24px]"
            />
            <CardSummary
              img={red}
              title="Total Payout"
              body="₦32,038,039"
              titleClassName="text-sm"
              bodyClassName="text-[24px]"
            />
          </div>
        </div>
        <div className="bg-white rounded-lg p-8">
          <div className="flex items-center justify-between pb-3 border border-transparent border-b-[#E1E4EA]">
            <div className="flex items-center gap-2">
              <img src={bank} alt="bank" />
              <p className="font-medium text-black text-base">
                Account Details
              </p>
            </div>
            <button className="px-4 py-[6px] rounded-full border border-[#F2F4F7] text-sm text-black flex items-center gap-1  ">
              <img src={copy} alt="copy" />
              Copy
            </button>
          </div>
          <div className="mt-4 flex flex-col gap-8">
            <div className="flex items-center justify-between text-sm">
              <p className="text-[#868C98]">Bank Name</p>
              <p className="text-black font-medium">Sterling Bank PLC</p>
            </div>
            <div className="flex items-center justify-between text-sm">
              <p className="text-[#868C98]">Account Name</p>
              <p className="text-black font-medium">Dojah Company</p>
            </div>
            <div className="flex items-center justify-between text-sm">
              <p className="text-[#868C98]">Account Number</p>
              <p className="text-black font-medium flex items-center   gap-2">
                00190289230{' '}
                <span className="cursor-pointer">
                  {' '}
                  <img src={copy} alt="copy" />
                </span>
              </p>
            </div>{' '}
          </div>
        </div>
      </div>
      <TableLayout negativeMargins className="w-full mt-4">
        <thead className="text-small font-semibold uppercase">
          <tr className="bg-white80">
            <td className="p-5 pl-12 font-medium text-left text-[10px] text-grey whitespace-nowrap">
              name
            </td>
            <td className="p-5 pl-0 font-medium text-left text-[10px] text-grey whitespace-nowrap">
              date created
            </td>
            <td className="p-5 pl-0 font-medium text-left text-[10px] text-grey whitespace-nowrap">
              amount
            </td>
            <td className="p-5 pl-0 font-medium text-left text-[10px] text-grey whitespace-nowrap">
              channel
            </td>
            <td className="p-5 pl-0 font-medium text-left text-[10px] text-grey whitespace-nowrap">
              type
            </td>
            <td className="p-5 pl-0 font-medium text-left text-[10px] text-grey whitespace-nowrap">
              ref id
            </td>
            <td className="p-5 pl-0 font-medium text-left text-[10px] text-grey whitespace-nowrap">
              status
            </td>

            <td className="p-5 pl-0 "></td>
          </tr>
        </thead>
        <tbody className="text-[13px] text-body bg-white">
          <tr className="text-left border-b bg-white border-grey60">
            <td className="p-4 pl-12 whitespace-nowrap">Ayomide Oso</td>
            <td className="p-4 pl-0 whitespace-nowrap">
              14th, May 2022, 5:09pm
            </td>
            <td className="p-4 pl-0 whitespace-nowrap">₦958,450</td>{' '}
            <td className="p-4 pl-0 whitespace-nowrap"> wallet</td>
            <td className="p-4 pl-0 whitespace-nowrap">credit</td>{' '}
            <td className="p-4 pl-0 whitespace-nowrap">TNX53726535626828</td>{' '}
            <td className="p-4 pl-0 whitespace-nowrap">successful</td>{' '}
            <td className="p-4 pl-0 whitespace-nowrap flex items-center gap-4 justify-between">
              <button>
                <img alt={'img'} src={eye} />
              </button>
            </td>
          </tr>
        </tbody>
      </TableLayout>
    </DashboardLayout>
  );
}

export default CustomerWalletDetails;
